import { useState } from "react";
import PropTypes from "prop-types";
import Button from "@shared/v2/Button";
import Dropdown from "@shared/v2/Dropdown";
import { AngleDownSolidV6 } from "@shared/v2/Icomoon";

const SortFields = {
  first_name: "First Name",
  last_name: "Last Name",
  status: "Status",
  stage: "Stage",
  last_interaction_interacted_at: "Last Interaction",
  primary_agent_full_name: "Primary Agent",
  assigned_plans_activity_date: "Auto Plans",
  birthdate: "Birthdate",
  anniversary: "Home Anniversary",
  home_app_invite_sent: "Home App",
  idx_last_visit: "Last Visit",
  idx_visits: "Visits",
  idx_property_views: "Views",
  idx_average_price: "Avg. View Price",
  idx_favorites: "Favorites",
  idx_average_price_favorited: "Avg. Fav. Price",
  idx_alerts: "Listing Alerts",
  last_sent_listing_alert: "Last Sent",
  last_opened_listing_alert: "Last Opened (Alerts)",
  market_report_count: "Market Reports",
  last_opened_market_report: "Last Opened (Reports)",
  last_viewed_market_report: "Last Viewed",
  hot_lead_score: "Hot Score",
  "sources.name": "Source",
  submitted_at: "Registered",
  user_type: "User Type",
};

const SortOrder = {
  asc: "Ascending",
  desc: "Descending",
};

const createOptions = (opts) => Object.entries(opts).map(([value, label]) => ({ value, label }));

const fieldOptions = createOptions(SortFields);
const orderOptions = createOptions(SortOrder);

const SortMenu = ({ sortField = "", sortOrder = "desc", onSave = () => {} }) => {
  const [open, setOpen] = useState(false);
  const [field, setField] = useState(sortField);
  const [order, setOrder] = useState(sortOrder || "desc");

  const handleSave = () => {
    onSave(field, order);
    setOpen(false);
  };

  return (
    <>
      <Button
        className="tw-flex tw-items-center tw-gap-[4px]"
        schema="secondary"
        size="small"
        onClick={() => setOpen(!open)}
      >
        <span className="tw-inline-flex tw-items-center">
          SORT BY{sortField ? `: ${SortFields[sortField]}` : ""}
        </span>
        <AngleDownSolidV6 />
      </Button>
      {open && (
        <>
          <div className="tw-absolute tw-flex tw-items-center tw-right-0 tw-top-32px tw-flex-row tw-h-[68px] tw-p-16px tw-z-50 tw-bg-white tw-shadow-modal">
            <div className="tw-mr-8px tw-w-[200px]">
              <Dropdown
                isSearchable
                isClearable={false}
                menuShouldComeToFront
                options={fieldOptions}
                onChange={(e) => setField(e?.value || "")}
                value={fieldOptions.find((f) => f.value === field)}
                placeholder="Field..."
              />
            </div>
            <div className="tw-mr-8px tw-w-[130px]">
              <Dropdown
                isSearchable={false}
                isClearable={false}
                menuShouldComeToFront
                options={orderOptions}
                onChange={(e) => setOrder(e?.value || "desc")}
                value={orderOptions.find((o) => o.value === order)}
              />
            </div>
            <Button disabled={!field} onClick={handleSave}>
              Save
            </Button>
          </div>
          <div
            role="presentation"
            className="tw-fixed tw-z-40 tw-inset-0 tw-bg-transparent"
            onClick={() => setOpen(false)}
          />
        </>
      )}
    </>
  );
};

SortMenu.propTypes = {
  sortField: PropTypes.string,
  sortOrder: PropTypes.string,
  onSave: PropTypes.func,
};

export default SortMenu;
